<!-- AI健康仓库管理 -->
<template>
  <div>
    <el-form :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="问题">
        <el-input v-model="queryParams.question"
                  placeholder="请输入问题"
                  clearable
                  size="small"
                  @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status"
                   placeholder="全部"
                   clearable
                   size="small">
          <el-option label="启用"
                     value="0"></el-option>
          <el-option label="删除"
                     value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   size="mini"
                   @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   plain
                   icon="el-icon-plus"
                   size="mini"
                   @click="openAdd">添加</el-button>
      </el-form-item>
    </el-form>
    <el-card>
      <el-table :data="tableData"
                align="center"
                style="width: 100%"
                :header-cell-style="{background: '#f8f8f9'}">
        <el-table-column label="编号"
                         align="center"
                         width="80">
          <template slot-scope="scope">
            {{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="问题"
                         align="center"
                         prop="question"
                         min-width="160"
                         show-overflow-tooltip />
        <el-table-column label="答案"
                         align="center"
                         prop="answer"
                         min-width="200"
                         show-overflow-tooltip />
        <el-table-column label="图片回答"
                         align="center"
                         min-width="120">
          <template slot-scope="scope">
            <el-image v-if="answerImages(scope.row)"
                      style="width: 48px; height: 48px"
                      :src="answerImages(scope.row)"
                      :preview-src-list="[answerImages(scope.row)]"
                      fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         align="center"
                         width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0"
                    type="success">启用</el-tag>
            <el-tag v-else-if="scope.row.status == 1"
                    type="info">删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         min-width="150"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.created || scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间"
                         align="center"
                         min-width="150"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.updated || scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="90">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       icon="el-icon-edit"
                       @click="editRow(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="pagination">
        <pagination v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList" />
      </el-row>
    </el-card>
    <el-dialog title="编辑"
               :visible.sync="editVisible"
               width="560px">
      <el-form :model="editForm"
               label-width="80px">
        <el-form-item label="问题">
          <el-input v-model="editForm.question"
                    type="textarea"
                    :rows="2"
                    maxlength="100"
                    placeholder="请输入问题"></el-input>
        </el-form-item>
        <el-form-item label="答案">
          <el-input v-model="editForm.answer"
                    type="textarea"
                    :rows="6"
                    :autosize="{ minRows: 4, maxRows: 12 }"
                    show-word-limit
                    maxlength="2000"
                    placeholder="请输入答案"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload action="#"
                     list-type="picture-card"
                     :auto-upload="false"
                     :limit="1"
                     :file-list="imageFileList"
                     :on-change="imageChange"
                     :on-remove="imageRemove"
                     accept="image/*">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.status"
                     placeholder="请选择状态">
            <el-option label="启用"
                       :value="0"></el-option>
            <el-option label="删除"
                       :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加"
               :visible.sync="addVisible"
               width="560px">
      <el-form :model="addForm"
               label-width="80px">
        <el-form-item label="问题"
                      required>
          <el-input v-model="addForm.question"
                    type="textarea"
                    :rows="2"
                    maxlength="100"
                    placeholder="请输入问题"></el-input>
        </el-form-item>
        <el-form-item label="答案">
          <el-input v-model="addForm.answer"
                    type="textarea"
                    :rows="6"
                    :autosize="{ minRows: 4, maxRows: 12 }"
                    show-word-limit
                    maxlength="2000"
                    placeholder="请输入答案"></el-input>
        </el-form-item>
        <el-form-item label="图片">
          <el-upload :key="addUploadKey"
                     action="#"
                     list-type="picture-card"
                     :auto-upload="false"
                     :limit="1"
                     :file-list="addImageFileList"
                     :on-change="addImageChange"
                     :on-remove="addImageRemove"
                     accept="image/*">
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="form-tip">答案和图片至少填写一项</div>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="addForm.status"
                     placeholder="请选择状态">
            <el-option label="启用"
                       :value="0"></el-option>
            <el-option label="删除"
                       :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        question: '',
        status: ''
      },
      total: 0,
      tableData: [],
      editVisible: false,
      editForm: {
        id: '',
        question: '',
        answer: '',
        status: 0
      },
      imageFileList: [],
      imageFile: null,
      addVisible: false,
      addForm: {
        question: '',
        answer: '',
        status: 0
      },
      addImageFileList: [],
      addImageFile: null,
      addUploadKey: 0
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    search() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    editRow(row) {
      this.editForm = {
        id: row.id,
        question: row.question || '',
        answer: row.answer || '',
        status: Number(row.status)
      }
      this.imageFile = null
      const url = this.answerImages(row)
      this.imageFileList = url ? [{ name: 'image', url }] : []
      this.editVisible = true
    },
    imageChange(file, fileList) {
      const isImage = file.raw && file.raw.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.error('只能上传图片')
        this.imageFile = null
        this.imageFileList = fileList.slice(0, -1)
        return
      }
      this.imageFile = file.raw
      this.imageFileList = fileList.slice(-1)
    },
    imageRemove() {
      this.imageFile = null
      this.imageFileList = []
    },
    openAdd() {
      this.addForm = {
        question: '',
        answer: '',
        status: 0
      }
      this.addImageFile = null
      this.addImageFileList = []
      this.addUploadKey += 1
      this.addVisible = true
    },
    addImageChange(file, fileList) {
      const isImage = file.raw && file.raw.type.indexOf('image/') === 0
      if (!isImage) {
        this.$message.error('只能上传图片')
        this.addImageFile = null
        this.addImageFileList = fileList.slice(0, -1)
        return
      }
      this.addImageFile = file.raw
      this.addImageFileList = fileList.slice(-1)
    },
    addImageRemove() {
      this.addImageFile = null
      this.addImageFileList = []
    },
    async submitAdd() {
      const question = (this.addForm.question || '').trim()
      const answer = (this.addForm.answer || '').trim()
      if (!question) return this.$message.error('问题不能为空')
      if (!answer && !this.addImageFile) return this.$message.error('答案和图片请至少填写一项')
      const formData = new FormData()
      formData.append('question', question)
      formData.append('answer', answer)
      formData.append('status', this.addForm.status)
      if (this.addImageFile) formData.append('answerImages', this.addImageFile)
      const { data: res } = await this.$http.post('/admin/aiHealth/addAiHealth', formData)
      if (res.code != 200) return this.$message.error(res.msg)
      this.$message.success('添加成功')
      this.addVisible = false
      this.queryParams.pageNum = 1
      this.getList()
    },
    async submitEdit() {
      const question = (this.editForm.question || '').trim()
      const answer = (this.editForm.answer || '').trim()
      if (!question) return this.$message.error('问题不能为空')
      if (!answer && !this.imageFile && this.imageFileList.length === 0) {
        return this.$message.error('答案和图片请至少填写一项')
      }
      const formData = new FormData()
      formData.append('id', this.editForm.id)
      formData.append('question', question)
      formData.append('answer', answer)
      formData.append('status', this.editForm.status)
      if (this.imageFile) formData.append('answerImages', this.imageFile)
      const { data: res } = await this.$http.post('/admin/aiHealth/updateAiHealth', formData)
      if (res.code != 200) return this.$message.error(res.msg)
      this.$message.success('修改成功')
      this.editVisible = false
      this.getList()
    },
    answerImages(row) {
      const path = row.answerImages || row.answer_images
      if (!path) return ''
      if (/^https?:\/\//.test(path)) return path
      return this.$url + path
    },
    async getList() {
      const params = {
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize
      }
      if (this.queryParams.question) params.question = this.queryParams.question
      if (this.queryParams.status !== '' && this.queryParams.status != null) params.status = this.queryParams.status
      const { data: res } = await this.$http.get('/admin/aiHealth/getAiHealthList', { params })
      if (res.code != 200) return this.$message.error(res.msg)
      const data = res.data || {}
      this.tableData = Array.isArray(data) ? data : data.list || []
      this.total = Array.isArray(data) ? data.length : data.total || 0
    }
  }
}
</script>
<style lang='scss' scoped>
.pagination {
  padding-top: 10px;
  text-align: right;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}
</style>
